import { TrendingUp, Target, Users, BarChart3, Globe, Zap } from 'lucide-react';

export const mockHeroData = {
  email: 'info@digitronicks.com',
  experience: 15,
  capabilities: [
    'Programmatic Advertising',
    'Publisher Network Management',
    'Advertiser Campaign Solutions',
    'Revenue Optimization',
    'Real-Time Bidding (RTB)',
    'Performance Analytics',
    'Brand Safety & Fraud Prevention'
  ]
};

export const mockDomains = [
  {
    title: 'CPC',
    description: 'Digitronicks excels in delivering Cost-Per-Click (CPC) advertising services, ensuring maximum ROI through targeted traffic and optimized bidding strategies.'
  },
  {
    title: 'CPS',
    description: 'Our Cost-Per-Sale (CPS) model drives actual sales conversions, connecting advertisers with high-quality publishers for performance-based marketing excellence.'
  },
  {
    title: 'CPM',
    description: 'Maximize brand visibility with our Cost-Per-Mille (CPM) solutions, delivering impressions at scale across premium publisher networks worldwide.'
  },
  {
    title: 'PROGRAMMATIC',
    description: 'Leverage our advanced programmatic advertising platform with real-time bidding, automated optimization, and AI-driven targeting for superior campaign performance.'
  },
  {
    title: 'PERFORMANCE',
    description: 'Our performance marketing solutions focus on measurable results, combining data analytics, conversion tracking, and continuous optimization to drive business growth.'
  }
];

export const mockServices = [
  {
    title: 'AD NETWORK MANAGEMENT',
    description: 'Comprehensive ad network solutions connecting premium publishers with top-tier advertisers, ensuring optimal fill rates and revenue maximization.',
    icon: <Globe size={40} />,
    iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  },
  {
    title: 'PUBLISHER SOLUTIONS',
    description: 'Empower your digital properties with our publisher platform offering competitive eCPMs, multiple ad formats, and advanced monetization tools.',
    icon: <TrendingUp size={40} />,
    iconBg: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
  },
  {
    title: 'ADVERTISER PLATFORM',
    description: 'Reach your target audience efficiently with our advertiser dashboard featuring real-time analytics, granular targeting, and campaign optimization tools.',
    icon: <Target size={40} />,
    iconBg: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
  },
  {
    title: 'PERFORMANCE TRACKING',
    description: 'Advanced analytics and reporting suite providing deep insights into campaign performance, user behavior, and conversion attribution.',
    icon: <BarChart3 size={40} />,
    iconBg: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
  },
  {
    title: 'AUDIENCE TARGETING',
    description: 'Precision targeting capabilities using demographic, behavioral, contextual, and geo-location data to reach the right users at the right time.',
    icon: <Users size={40} />,
    iconBg: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
  },
  {
    title: 'RTB SOLUTIONS',
    description: 'Real-time bidding infrastructure enabling millisecond auction transactions with transparent pricing and maximum efficiency for both buyers and sellers.',
    icon: <Zap size={40} />,
    iconBg: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)'
  }
];

export const mockClients = [
  {
    name: 'TechCorp',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=TechCorp'
  },
  {
    name: 'GlobalMedia',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=GlobalMedia'
  },
  {
    name: 'AdPro',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=AdPro'
  },
  {
    name: 'DigitalFirst',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=DigitalFirst'
  },
  {
    name: 'MediaHub',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=MediaHub'
  },
  {
    name: 'AdNetwork+',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=AdNetwork%2B'
  },
  {
    name: 'PublishPro',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=PublishPro'
  },
  {
    name: 'TrafficMax',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=TrafficMax'
  },
  {
    name: 'BrandBoost',
    logo: 'https://via.placeholder.com/150x60/1a1a1a/00CED1?text=BrandBoost'
  }
];

export const mockStats = [
  { label: 'Publishers', value: 500 },
  { label: 'Advertisers', value: 800 },
  { label: 'Daily Impressions (M)', value: 250 },
  { label: 'Countries', value: 85 }
];
